<form [formGroup]="formGroup">
    <div class="row">
        <div class="col-12 col-xl-6 left-block">
            <div class="form-group">
                <div class="col">
                    <label>{{ 'cerrixRecurrence.repeat' | transloco }}</label>
                    <ng-select
                        data-uiid="recurrence-repeat"
                        bindValue="ID"
                        bindLabel="Name"
                        [items]="frequencies"
                        [clearable]="false"
                        formControlName="frequency"
                        (change)="frequencyChanged($event)"
                    >
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6 left-block">
                <div class="form-group">
                    <label>{{ 'cerrixRecurrence.repeatEvery' | transloco }}</label>
                    <div style="display: flex" class="input-group">
                        <input
                            data-uiid="recurrence-repeat-every"
                            type="number"
                            min="1"
                            max="frequencycount"
                            formControlName="interval"
                            class="form-control col-5"
                        />

                        <span class="input-group-text" style="margin-left: 5px">{{ 'cerrixRecurrence.frequencyUnit' | transloco: { frequency: recurrenceFrequencys[model.frequency] } }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if (model.frequency === recurrenceFrequencys.Weekly) {
        <div>
            <div class="form-group">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div><label>{{ 'cerrixRecurrence.repeatOn' | transloco }}</label></div>
                        <div
                            class="btn-group"
                            role="group"
                            aria-label="Basic checkbox toggle button group"
                            id="weeklyDiv"
                        >
                            <mat-chip-listbox
                                multiple
                                [matTooltip]="'cerrixRecurrence.selectDaysTooltip' | transloco"
                                [disabled]="byDayDisabled"
                            >
                                @for (weekDay of weekDays; track weekDay.value) {
                                    <mat-chip-option
                                        [selectable]="!byDayDisabled"
                                        selected="{{ model.byDay.includes(weekDay.value) }}"
                                        (click)="toggleWeekDay($event, weekDay)"
                                        [disabled]="byDayDisabled"
                                    >
                                        {{ weekDay.label }}
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } @else if (
        model.frequency === recurrenceFrequencys.Monthly ||
        model.frequency === recurrenceFrequencys.Yearly
    ) {
        <div class="form-group">
            <div class="row rowmargin">
                <div class="col-12 col-xl-6 left-block">
                    <div>
                        <label>{{ 'cerrixRecurrence.repeatOn' | transloco }}</label>
                    </div>
                    @if (model.frequency === recurrenceFrequencys.Yearly) {
                        <div>
                            <ng-select
                                formControlName="byMonth"
                                data-uiid="recurrence-when-monthselection"
                                bindValue="ID"
                                bindLabel="Name"
                                [items]="months"
                            >
                            </ng-select>
                        </div>
                    }
                </div>
            </div>
            @if (
                !(
                    byDayDisabled &&
                    (model.radioSelection === "WorkDay" || model.radioSelection === "Other")
                )
            ) {
                <div class="row rowmargin">
                    <div class="col-12 col-xl-6 left-block">
                        <div style="display: flex">
                            <div class="col-1">
                                <input
                                    type="radio"
                                    name="abc"
                                    id="radioDay"
                                    value="Day"
                                    style="margin-right: 5px"
                                    [disabled]="byDayDisabled"
                                    [checked]="model.radioSelection === 'Day'"
                                    [(ngModel)]="model.radioSelection"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="onRadioChanged($event)"
                                />
                            </div>
                            <div class="col-2">
                                <label style="margin-right: 5px" for="a">{{ 'cerrixRecurrence.day' | transloco }}</label>
                            </div>
                            <input
                                data-uiid="recurrence-daynumber"
                                type="number"
                                min="1"
                                max="31"
                                [required]="model.radioSelection === 'Day'"
                                formControlName="byMonthDay"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            }

            @if (
                !(
                    byDayDisabled &&
                    (model.radioSelection === "Day" || model.radioSelection === "WorkDay")
                )
            ) {
                <div class="row rowmargin">
                    <div class="col-12 col-xl-6 left-block">
                        <div style="display: flex">
                            <div class="col-1">
                                <input
                                    type="radio"
                                    name="abc"
                                    id="radioOther"
                                    value="Other"
                                    style="margin-right: 5px"
                                    [(ngModel)]="model.radioSelection"
                                    [disabled]="byDayDisabled"
                                    [checked]="model.radioSelection === 'Other'"
                                    [required]="model.radioSelection === 'Other'"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="onRadioChanged($event)"
                                />
                            </div>
                            <div class="col-2">
                                <label style="margin-right: 5px" for="a">{{ 'cerrixRecurrence.weekDay' | transloco }}</label>
                            </div>
                            <ng-select
                                class="col-4"
                                data-uiid="recurrence-when-selection"
                                bindValue="ID"
                                bindLabel="Name"
                                [items]="whenSelection"
                                formControlName="otherByDayType"
                            >
                            </ng-select>
                            <ng-select
                                class="col-5"
                                data-uiid="recurrence-when-day-selection"
                                bindValue="Key"
                                bindLabel="Value"
                                [items]="daySelection"
                                formControlName="otherByDay"
                            >
                            </ng-select>
                        </div>
                    </div>
                </div>
            }
            @if (
                !(
                    byDayDisabled &&
                    (model.radioSelection === "Day" || model.radioSelection === "Other")
                ) && model.frequency === recurrenceFrequencys.Monthly
            ) {
                <div>
                    <div class="row rowmargin">
                        <div class="col-12 col-xl-6 left-block">
                            <div style="display: flex">
                                <div class="col-1">
                                    <input
                                        type="radio"
                                        name="abc"
                                        id="radioWorkDay"
                                        value="WorkDay"
                                        style="margin-right: 5px"
                                        [disabled]="byDayDisabled"
                                        [checked]="model.radioSelection === 'WorkDay'"
                                        [(ngModel)]="model.radioSelection"
                                        [ngModelOptions]="{ standalone: true }"
                                        (change)="onRadioChanged($event)"
                                    />
                                </div>
                                <div class="col-2">
                                    <label style="margin-right: 5px" for="a">{{ 'cerrixRecurrence.workDay' | transloco }}</label>
                                </div>
                                <input
                                    data-uiid="recurrence-workdaynumber"
                                    type="number"
                                    min="1"
                                    max="31"
                                    formControlName="byMonthWorkDay"
                                    class="form-control"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row rowmargin dark-grey">
                        <div class="col-12 col-xl-6 left-block">
                            <div style="display: flex">
                                <div class="col-1"></div>
                                <div class="col-2"></div>
                                <div class="iconmargin">
                                    <mat-icon fontSet="material-icons-outlined">error</mat-icon>
                                </div>
                                <div>
                                    <label style="margin-right: 5px" class="info-label"
                                        >{{ 'cerrixRecurrence.workDayInfo' | transloco }}</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    <div class="row">
        <div class="col-12 col-xl-6 left-block">
            <div class="form-group">
                <label>{{ 'cerrixRecurrence.startDate' | transloco }}</label>
                <date-input
                    data-uiid="recurrence-startdate"
                    formControlName="startdate"
                ></date-input>
            </div>
            <div class="form-group">
                <label>{{ 'cerrixRecurrence.endDate' | transloco }}</label>
                <date-input data-uiid="recurrence-enddate" formControlName="enddate"></date-input>
            </div>
        </div>
    </div>
</form>
